/** Presentation for the shared Big 5 / LATAM preset buttons. */

import { memo } from "react";

import { Pressable } from "@/components/atoms/Pressable";
import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";

/** Preset control presentation props. */
interface Props {
  readonly big5Selected: boolean;
  readonly big5Disabled: boolean;
  readonly latamSelected: boolean;
  readonly latamDisabled: boolean;
  readonly onToggleBig5: () => void;
  readonly onToggleLatam: () => void;
}

/**
 * Renders the available Big 5 and LATAM league preset toggles.
 * @param props - Resolved presentation props
 */
const LeaguePresetControlsView = (props: Props) => (
  <Stack direction="horizontal" className="gap-2">
    <Pressable
      accessibilityRole="button"
      accessibilityLabel="Big 5 league preset"
      accessibilityState={{
        selected: props.big5Selected,
        disabled: props.big5Disabled,
      }}
      aria-pressed={props.big5Selected}
      disabled={props.big5Disabled}
      onPress={props.onToggleBig5}
      testID="player-filter:big5-preset"
      className={`rounded-sm border px-3 py-2 ${
        props.big5Selected
          ? "border-accent-primary bg-accent-primary/15"
          : "border-outline-strong bg-surface-raised"
      } ${props.big5Disabled ? "opacity-40" : "opacity-100"}`}
    >
      <Text variant="caption" className="text-content-primary">
        Big 5
      </Text>
    </Pressable>
    <Pressable
      accessibilityRole="button"
      accessibilityLabel="LATAM league preset"
      accessibilityState={{
        selected: props.latamSelected,
        disabled: props.latamDisabled,
      }}
      aria-pressed={props.latamSelected}
      disabled={props.latamDisabled}
      onPress={props.onToggleLatam}
      testID="player-filter:latam-preset"
      className={`rounded-sm border px-3 py-2 ${
        props.latamSelected
          ? "border-accent-primary bg-accent-primary/15"
          : "border-outline-strong bg-surface-raised"
      } ${props.latamDisabled ? "opacity-40" : "opacity-100"}`}
    >
      <Text variant="caption" className="text-content-primary">
        LATAM
      </Text>
    </Pressable>
  </Stack>
);

LeaguePresetControlsView.displayName = "LeaguePresetControlsView";

export default memo(LeaguePresetControlsView);
